module.exports = __webpack_public_path__ + "static/media/refercode.9369b5a6.png";